import * as THREE from 'three';
import pnoise from 'glsl-noise/periodic/3d.glsl';
import fbm from 'shaders/fbm.glsl';

const shader = THREE.ShaderLib.standard;

let vert = shader.vertexShader;
let frag = shader.fragmentShader;

const vert_head = `
    uniform float uNoise;
    uniform float uTime;
    uniform vec3 uIntersectPoint;
    uniform float uRecees;
    
    varying float vIntersected;
    varying vec3 vPosition;
    varying vec2 vUv;
    
    ${pnoise}
`;

const project_vertex = `
    vUv = uv;
    vec4 mvPosition = vec4(transformed, 1.);
    
    mvPosition.xyz *= 1. + (pnoise((transformed * 0.4 + uTime), vec3(20., 40., 60.)) * (0.08 * uNoise));
    
    #ifdef USE_INSTANCING
        mvPosition = instanceMatrix * mvPosition;
    #endif
    mvPosition = modelViewMatrix * mvPosition;
    vPosition = mvPosition.xyz;
`;

const fog_vertex = `
    #include <fog_vertex>
    
    float distance = length(uIntersectPoint.xyz - mvPosition.xyz);
    float recees = clamp(0., 1., distance);
    float flip = -uRecees * (recees - 1.);
    float currentHole = flip * .6 * sign(uIntersectPoint).z;
    
    mvPosition.z += currentHole;
    
    gl_Position = projectionMatrix * mvPosition;
    
`;

vert = vert.replace('#include <project_vertex>', project_vertex);
vert = vert.replace('#include <fog_vertex>', fog_vertex);
vert = vert.replace('#include <project_vertex>', project_vertex);


const dithering_fragment = `
    #include <dithering_fragment>
    
    
    //CUT CIRCLE
    
    float dist = length(uIntersectPoint.xyz - vPosition.xyz);
    float circle = step(0.0001 + 2. * (uPopTime * uTempo), dist + fbm(2.*vPosition.xyz) * (0.3 * uDistortionLevel));
    
    gl_FragColor.a *= circle;
`;

const frag_head = `
    uniform float uTime;
    uniform vec3 uIntersectPoint;
    uniform float uPopTime;
    uniform float uDistortionLevel;
    uniform float uTempo;
    
    varying vec3 vPosition;
    ${fbm}
`;

export const vertex = vert_head + vert;

frag = frag.replace('#include <dithering_fragment>', dithering_fragment);
export const fragment = frag_head + frag;
